// extracted by mini-css-extract-plugin
module.exports = {"wrap":"TextBox_wrap__3h9vc","visibleWrap":"TextBox_visibleWrap__1ooS0","invisibleWrap":"TextBox_invisibleWrap__3x6SK"};